import { ApiResponse } from "../types";
import { apiClient } from "./apiClient";

export interface RevenueTargetAiSuggestionItem {
  serviceId: number;
  serviceName: string;
  units: number;
  unitPrice: number;
  revenue: number;
}

export interface RevenueTargetAiStrategy {
  title: string;
  summary: string;
  items: RevenueTargetAiSuggestionItem[];
  totalRevenue: number;
}

export interface GenerateRevenueTargetSuggestionsPayload {
  month: number;
  year: number;
  targetAmount: number;
  currentRevenue: number;
}

const aiApi = {
  async generateRevenueTargetSuggestions(
    payload: GenerateRevenueTargetSuggestionsPayload
  ): Promise<ApiResponse<{ strategies: RevenueTargetAiStrategy[] }>> {
    try {
      const response = await apiClient.post<{
        message: string;
        data: { strategies: RevenueTargetAiStrategy[] };
      }>("/ai/revenue-target-suggestions", payload);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : "Não foi possível gerar sugestões com IA.",
      };
    }
  },
};

export { aiApi };
